import React from "react";
import SensorAnalysisManager from "./SensorAnalysisManager";
import ManualMeshingPlacementControls from "./ManualMeshingPlacementControls";
import WindowSelectionBox from "../objectSelection/WindowSelectionBox";
import SensorSkyline from "./SensorSkyline";
import WindowSkyline from "./WindowSkyline";

const SensorAnalysisRoot = () => {
  return (
    <>
      <ManualMeshingPlacementControls />
      <SensorAnalysisManager />
      <WindowSelectionBox />
      <SensorSkyline />
      <WindowSkyline />
    </>
  );
};

export default SensorAnalysisRoot;
